import { render, staticRenderFns } from "./AvatarIconEditable.vue?vue&type=template&id=2df68340&scoped=true&"
import script from "./AvatarIconEditable.vue?vue&type=script&lang=js&"
export * from "./AvatarIconEditable.vue?vue&type=script&lang=js&"
import style0 from "./AvatarIconEditable.vue?vue&type=style&index=0&id=2df68340&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df68340",
  null
  
)

export default component.exports